import * as allIcons from '@blocksuite/icons/rc';
import type { SVGProps } from 'react';

import { GoldllenIcon } from '../../../components/brand';

export const isLegacyBrandIcon = (name: string) =>
  /^(?:Logo[1-4](?:Duotone)?|AfFiNe|Goldllen)$/i.test(name);

export const AffineIconRenderer = ({
  name,
  ...props
}: {
  name: string;
} & SVGProps<SVGSVGElement>) => {
  if (isLegacyBrandIcon(name)) {
    return <GoldllenIcon {...props} />;
  }

  const Icon = allIcons[
    `${name}Icon` as keyof typeof allIcons
  ] as React.ComponentType<React.SVGProps<SVGSVGElement>>;

  if (!Icon) {
    return null;
  }

  return <Icon {...props} />;
};
